export default __webpack_public_path__ + "static/media/mclogo.953654bf.png";